<template>
  <div>
    <pbas-data-table
      v-if="provider"
      :exporters="$exporters"
      ref="table"
      :dataProvider="provider"
      fileNamePrefix="member-sick-payment-balance"
      :identifier="'member_sick_payment_balance_table' + selectedPlan.Id"
      @error="error = $event"
      :show-select="false"
      :sortBy="'Term/EndDate'"
      :sortDescending="true"
    ></pbas-data-table>
    <v-container fluid grid-list-md v-else>
      <v-layout row justify-center>
        <v-flex xs12 sm6 md4 lg3>
          <v-progress-circular indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import BalanceHistoryHeaders from "@/headers/MemberSickPaymentBalance";
import ErrorHandler from "@/components/ErrorHandler";

export default {
  props: ["memberIdentityId"],
  components: {
    ErrorHandler,
  },
  data() {
    return {
      provider: null,
      error: null,
    };
  },
  methods: {
    async loadData() {
      const headers = BalanceHistoryHeaders;
      if (this.memberIdentityId) {
        const url = `/plans/${this.selectedPlan.Id}/member-info/${
          this.memberIdentityId
        }/sick-payment-balance`;
        this.provider = new ODataProvider(this.$axiosHttp, url, headers);
      }
    },
    reload() {
      if (this.$refs.table) {
        this.$refs.table.getDataAsync();
      }
    }
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  watch: {
    memberIdentityId: {
      handler: function() {
        if (this.provider === null || this.provider === undefined) {
          this.loadData();
        }
      },
    },
  },
  mounted() {
    if (this.memberIdentityId !== null && this.memberIdentityId !== undefined) {
      this.loadData();
    }
  },
};
</script>
